<template>
  <div class="offer" v-bind:style="{ color: background, background: hex}">

   <div class="content">
    <svg class="get-the-app"  :fill="background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 421 58"><path d="M28.5 39.3c-2.8 2.6-6 3.9-9.7 3.9-2.4 0-4.7-.5-6.9-1.4s-4-2.2-5.6-3.9c-1.6-1.7-2.9-3.7-3.8-6S1 27 1 24.2c0-2.5.5-4.9 1.4-7.2s2.2-4.2 3.9-5.9 3.6-3 5.9-3.9 4.7-1.5 7.3-1.5c3.4 0 6.4.7 9 2.2s4.5 3.4 5.8 5.9L28 18.6c-.8-1.7-2-3-3.6-3.9-1.6-.9-3.3-1.4-5.1-1.4-1.4 0-2.7.3-3.9.9s-2.2 1.4-3 2.4-1.5 2.2-1.9 3.6c-.5 1.4-.7 2.8-.7 4.4 0 1.6.2 3.1.7 4.4.5 1.4 1.2 2.5 2 3.5.9 1 1.9 1.8 3.1 2.3 1.2.6 2.5.8 4 .8 3.3 0 6.3-1.5 9-4.6v-1.1h-7.2v-6.2h14.2V43h-7.1v-3.7zm25 4.2c-2.3 0-4.3-.4-6.2-1.1-1.8-.7-3.4-1.8-4.6-3s-2.2-2.8-2.9-4.4c-.7-1.7-1-3.4-1-5.3 0-2 .3-3.8 1-5.6s1.6-3.3 2.9-4.6c1.2-1.3 2.8-2.4 4.6-3.1 1.8-.8 3.9-1.1 6.2-1.1 2.3 0 4.4.4 6.2 1.1 1.8.8 3.3 1.8 4.6 3.1 1.2 1.3 2.2 2.8 2.8 4.5.6 1.7 1 3.5 1 5.4 0 .5 0 1-.1 1.4 0 .5-.1.9-.2 1.2H47.7c.1 1.8.8 3.2 2 4.2s2.6 1.4 4.1 1.4c1.2 0 2.4-.3 3.5-.9 1.1-.6 1.9-1.4 2.3-2.4l7.1 2c-1.1 2.1-2.7 3.9-5 5.2-2.3 1.3-5 2-8.2 2zm5.8-16.8c-.2-1.7-.8-3.1-1.9-4.1s-2.4-1.5-4-1.5-3 .5-4 1.5-1.7 2.4-1.8 4.1h11.7zm30.3 14.8c-1.1.5-2.5.9-3.9 1.4-1.5.4-3 .6-4.4.6-1 0-2-.1-2.9-.4-.9-.3-1.7-.7-2.4-1.2s-1.2-1.3-1.6-2.3c-.4-.9-.6-2.1-.6-3.4V21.9h-3.5v-6.3h3.5V7h8.3v8.7h5.6V22h-5.6v11.4c0 .9.2 1.6.7 1.9.5.4 1 .6 1.7.6.6 0 1.3-.1 1.9-.3.7-.2 1.2-.4 1.7-.7l1.5 6.6zm33 0c-1.1.5-2.5.9-3.9 1.4-1.5.4-3 .6-4.4.6-1 0-2-.1-2.9-.4-.9-.3-1.7-.7-2.4-1.2s-1.2-1.3-1.6-2.3c-.4-.9-.6-2.1-.6-3.4V21.9h-3.5v-6.3h3.5V7h8.3v8.7h5.6V22h-5.6v11.4c0 .9.2 1.6.7 1.9.5.4 1 .6 1.7.6.6 0 1.3-.1 1.9-.3.7-.2 1.2-.4 1.7-.7l1.5 6.6zm29.5 1.4h-8.3V27.6c0-1.8-.3-3.1-1-3.9-.7-.8-1.6-1.2-2.9-1.2-.5 0-1 .1-1.6.3s-1.1.6-1.7 1c-.5.4-1 .9-1.5 1.5s-.8 1.2-1 2v15.6h-8.3V5h8.3v15.2c1-1.6 2.3-2.9 4-3.8 1.6-.9 3.5-1.3 5.4-1.3 1.8 0 3.3.3 4.4 1 1.1.6 2 1.5 2.6 2.4.6 1 1 2.1 1.2 3.3.2 1.2.3 2.4.3 3.6v17.5zm18.6.6c-2.3 0-4.3-.4-6.2-1.1-1.8-.7-3.4-1.8-4.6-3-1.3-1.3-2.2-2.8-2.9-4.4-.7-1.7-1-3.4-1-5.3 0-2 .3-3.8 1-5.6.7-1.7 1.6-3.3 2.9-4.6 1.2-1.3 2.8-2.4 4.6-3.1 1.8-.8 3.9-1.1 6.2-1.1s4.4.4 6.2 1.1c1.8.8 3.3 1.8 4.6 3.1 1.2 1.3 2.2 2.8 2.8 4.5s1 3.5 1 5.4c0 .5 0 1-.1 1.4s-.1.9-.2 1.2h-20.2c.1 1.8.8 3.2 2 4.2s2.6 1.4 4.1 1.4c1.2 0 2.4-.3 3.5-.9 1.1-.6 1.9-1.4 2.3-2.4l7.1 2c-1.1 2.1-2.7 3.9-5 5.2-2.2 1.3-5 2-8.1 2zm5.8-16.8c-.2-1.7-.8-3.1-1.9-4.1-1.1-1-2.4-1.5-4-1.5s-3 .5-4 1.5c-1.1 1-1.7 2.4-1.8 4.1h11.7zm32.4 16.8c-1.4 0-2.6-.2-3.8-.6s-2.2-1-3-1.8c-.8-.8-1.5-1.7-2-2.8-.5-1.1-.7-2.2-.7-3.5 0-1.4.3-2.6.9-3.7s1.4-2.1 2.4-2.9c1-.8 2.3-1.4 3.7-1.9s3-.7 4.7-.7c1.1 0 2.3.1 3.3.3 1.1.2 2 .5 2.8.9v-1.2c0-3.2-1.8-4.7-5.5-4.7-1.5 0-2.9.3-4.3.8s-2.8 1.3-4.3 2.3l-2.4-5.2c1.8-1.2 3.7-2.1 5.6-2.7 1.9-.6 4-.9 6.2-.9 4.1 0 7.3 1 9.6 2.9s3.4 4.8 3.4 8.5v7c0 .8.1 1.4.4 1.7.3.3.7.5 1.4.6v7c-.7.2-1.4.3-2 .3-.6.1-1.1.1-1.6.1-1.6 0-2.7-.3-3.5-.9s-1.3-1.5-1.5-2.6l-.2-1.2c-1.2 1.6-2.7 2.8-4.3 3.6-1.6.8-3.4 1.3-5.3 1.3zm2.5-6c.9 0 1.8-.2 2.6-.5s1.6-.7 2.1-1.2c.8-.6 1.2-1.3 1.2-2v-2.6c-.7-.3-1.5-.5-2.4-.6-.8-.2-1.6-.2-2.4-.2-1.5 0-2.8.3-3.8 1s-1.5 1.6-1.5 2.7c0 1 .4 1.8 1.1 2.5s1.9.9 3.1.9zm37.5 6c-2.1 0-3.9-.4-5.4-1.3-1.5-.9-2.7-2.1-3.5-3.6V54h-8.3V15.7h7.2v4.4c1-1.6 2.3-2.8 3.8-3.6 1.5-.9 3.3-1.3 5.4-1.3 1.8 0 3.5.4 5.1 1.1 1.5.7 2.9 1.7 4 3s2 2.8 2.7 4.5c.6 1.7 1 3.6 1 5.5 0 2-.3 3.9-.9 5.7-.6 1.7-1.4 3.2-2.4 4.5-1 1.3-2.3 2.3-3.7 3-1.7.6-3.3 1-5 1zm-2.8-7.1c.9 0 1.7-.2 2.5-.6.7-.4 1.4-.9 2-1.6.6-.7 1-1.4 1.3-2.3.3-.9.4-1.8.4-2.8 0-1-.2-1.9-.5-2.8-.3-.8-.8-1.6-1.4-2.2-.6-.6-1.3-1.1-2.1-1.5-.8-.3-1.7-.5-2.6-.5-1.1 0-2.2.3-3.3 1-1.1.7-1.9 1.6-2.4 2.7v5.6c.6 1.4 1.4 2.5 2.5 3.5s2.3 1.5 3.6 1.5zm36.1 7.1c-2.1 0-3.9-.4-5.4-1.3-1.5-.9-2.7-2.1-3.5-3.6V54H265V15.7h7.2v4.4c1-1.6 2.3-2.8 3.8-3.6 1.5-.9 3.3-1.3 5.4-1.3 1.8 0 3.5.4 5.1 1.1 1.5.7 2.9 1.7 4 3s2 2.8 2.7 4.5c.6 1.7 1 3.6 1 5.5 0 2-.3 3.9-.9 5.7-.6 1.7-1.4 3.2-2.4 4.5-1 1.3-2.3 2.3-3.7 3-1.7.6-3.3 1-5 1zm-2.8-7.1c.9 0 1.7-.2 2.5-.6.7-.4 1.4-.9 2-1.6.6-.7 1-1.4 1.3-2.3.3-.9.4-1.8.4-2.8 0-1-.2-1.9-.5-2.8-.3-.8-.8-1.6-1.4-2.2-.6-.6-1.3-1.1-2.1-1.5-.8-.3-1.7-.5-2.6-.5-1.1 0-2.2.3-3.3 1-1.1.7-1.9 1.6-2.4 2.7v5.6c.6 1.4 1.4 2.5 2.5 3.5s2.3 1.5 3.6 1.5zM18 52h207v2H18zM279 52h135v2H279zM246 52h13v2h-13zM405 4.4L402.7 2c-1.3-1.3-3.4-1.3-4.6 0l-2.8 2.9-1.6-1.6c-.4-.4-1-.4-1.3 0l-3.1 3.2c-.4.4-.4 1 0 1.4l1.7 1.7L377 24c-.2.2-.3.6-.3.8v3.7l-2 2.1c-.8.8-.8 2.1 0 2.9.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6l2-2.1h3.6c.3 0 .6-.1.8-.3l14-14.4 1.6 1.7c.4.4 1 .4 1.3 0l3.1-3.2c.4-.4.4-1 0-1.4l-1.6-1.6 2.8-2.9c1.2-1.4 1.2-3.6-.1-4.9zm-12.3 14.5h-8.2l7.4-7.7 4.1 4.2-3.3 3.5zM376 36c-1.3 3.1-2.8 4.2-3 6.2-.1 1.4.8 2.8 3 2.8 2.1 0 3.1-1.4 3-2.8-.2-2-1.7-3.1-3-6.2z"/></svg>
    
      <p>
       Would you like to be the first to try out the app with great features such as swatches &amp; eyedropper?            
      </p>

      <div id="mc_embed_signup" class="signup-form">
        <form action="https://robsarve.us20.list-manage.com/subscribe/post?u=76ad09e3cf8aed61d5ebd82f1&amp;id=5e55e804e3" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <!-- <form ref="mailChimpForm" action="localhost" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate> -->
            <div id="mc_embed_signup_scroll">
        <div class="mc-field-group">
      
   <div class="form-row">
      <div class="form-left">
      <div class="mc-field-group input-group intrested-in">
        I'm interested in a version for:
        <ul>
          <li>
            <styled-checkbox label="OS X" value="2" name="group[773][2]" id="mce-group[773]-773-0"
                :foreground="hex" :background="background" />
          </li>
          <li>
            <styled-checkbox label="Win" value="4" name="group[773][4]" id="mce-group[773]-773-1"
                :foreground="hex" :background="background" />
          </li>
          <li>
            <styled-checkbox label="iPhone" value="8" name="group[773][8]" id="mce-group[773]-773-2"
                :foreground="hex" :background="background" />
          </li>
          <li>
            <styled-checkbox label="Android" value="16" name="group[773][16]" id="mce-group[773]-773-3"
                :foreground="hex" :background="background" />
          </li>
        </ul> 
      </div>
      </div>

       <div class="form-right">

          <input type="email" value="" name="EMAIL" class="required email big" id="mce-EMAIL" placeholder="john@doe.com"
            v-bind:style="{
              background: background,
              color: hex
              }"
          >

           <input type="submit" value="Sign up" name="subscribe" id="mc-embedded-subscribe" class="button2 big"
                v-bind:style="{
                borderColor: background,
                background: background,
                color: hex
              }"/>
        </div>
     </div>

        </div>
          <div id="mce-responses" class="clear">
            <div class="response" id="mce-error-response" style="display:none"></div>
            <div class="response" id="mce-success-response" style="display:none"></div>
          </div>
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_76ad09e3cf8aed61d5ebd82f1_5e55e804e3" tabindex="-1" value=""></div>
            <div class="clear">
            </div>
          </div>
        </form>
      </div>
    </div>

      <offer-video :hex="hex"/>

  </div>
</template>
<script>
import OfferVideo from './OfferVideo.vue'
import StyledCheckbox from './StyledCheckbox.vue'

export default {
  props: ['hex'],
  components: { OfferVideo, StyledCheckbox },
  mounted() {
   
  },
  computed: {
    contrast() {
      return Number(this.$store.getters.contrast);
    },
    background() {
      return this.$store.getters.background.color.hex()
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import '../offer';
</style>
